import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { SHOP_SECTION_ID, scrollToSection } from '../../utils/scroll';
import { formatMoney, startingPrice } from '../../utils/pricing';
import { track } from '../../utils/analytics';
type ShopNowButtonProps = {
  size?: 'sm' | 'lg';
  className?: string;
  source: string;
  onActivate?: () => void;
  /** Adds a "— from $X/light" price anchor. */
  showPrice?: boolean;
};

/**
 * SHOP NOW — on the homepage scrolls to #shop-systems (Complete Systems +
 * Build Your Own). Elsewhere it returns to that homepage section.
 */
export function ShopNowButton({
  size = 'lg',
  className = '',
  source,
  onActivate,
  showPrice = false
}: ShopNowButtonProps) {
  const {
    t,
    lang
  } = useLanguage();
  const {
    pathname
  } = useLocation();
  const navigate = useNavigate();
  const go = () => {
    track('shop_now_click', {
      source
    });
    onActivate?.();
    if (pathname === '/') scrollToSection(SHOP_SECTION_ID);else navigate(`/#${SHOP_SECTION_ID}`);
  };
  const sizing = size === 'lg' ? 'h-14 px-7 text-[17px]' : 'h-10 px-4 text-[14px]';
  return <button type="button" onClick={go} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-xl border-2 border-marine bg-deep/80 font-display font-semibold uppercase tracking-[0.12em] text-white shadow-[0_0_14px_rgba(36,141,255,0.35)] transition-[background-color,box-shadow,transform] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-navy hover:shadow-[0_0_20px_rgba(36,141,255,0.5)] active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice ${sizing} ${className}`} data-id="element-987" data-mp="18llrhsv2yaea">
      {t('hero.shopNow')}
      {showPrice && <span className="font-medium normal-case tracking-[0.04em] text-ice" data-id="element-988" data-mp="3obpyt72jsfin">
          — {t('common.from').toLowerCase()} {formatMoney(startingPrice(), lang)}
        </span>}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden data-id="element-989" data-mp="1sao3mt76ools" />
    </button>;
}